export default __webpack_public_path__ + "static/media/about-active.c3fead9b.svg";